const fieldValidation = {
  required: '{{fieldName}} là bắt buộc',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
